
var f = true;

function caricaMenuHome(u, t, c, l) {
    if (f) {
        f = false;
        var e = document.createElement("script");
        e.type = "text/javascript";
        e.src = u + "/App/dist/browser-export.js";
        e.async = false;
        e.defer = false;
        e.onload = function () { window.inizializzaMenuHome(u, t, c, l) };
        var h = document.getElementsByTagName("head")[0];
        h.insertBefore(e, h.lastChild);
    }
}

module.exports = {
    inizializza: function (u, t, c, l) {
        setTimeout(() => caricaMenuHome(u, t, c, l));
    },
    cambiaUfficio: function (u) {
        window.modificaUfficioCorrenteMenuHome && window.modificaUfficioCorrenteMenuHome(u);
    }
}